"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../../config");
var requestAdapter_1 = require("../../internal/requestAdapter");
var tokenManager_1 = require("../core/tokenManager");
var UMSModule = (function () {
    function UMSModule() {
    }
    UMSModule.prototype.init = function (coreInjector) {
        this.tokenManager = coreInjector.get(tokenManager_1.TokenManager);
        this.requestAdapter = coreInjector.get(requestAdapter_1.RequestAdapter);
        this.projectId = coreInjector.get(tokenManager_1.AuthOptions).projectID;
        return Promise.resolve(this);
    };
    UMSModule.prototype.getConfig = function () {
        return { ums: {} };
    };
    UMSModule.prototype.terminate = function () {
        return Promise.resolve(this);
    };
    UMSModule.prototype.signIn = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            var _this = this;
            return __generator(this, function (_a) {
                body = {
                    method: "ums",
                    email: user.email,
                    password: user.password
                };
                return [2, this.requestAdapter.execute(this.getUrl(config_1.API.AUTH, false), { body: body, method: requestAdapter_1.RequestMethod.POST }).then(function (tokens) {
                        _this.tokenManager.addTokens([user.email, user.alias], tokens, user.default);
                        return tokens.access_token;
                    })];
            });
        });
    };
    UMSModule.prototype.signUp = function (credentials) {
        var body = {
            email: credentials.email,
            password: credentials.password
        };
        return this.requestAdapter.execute(this.getUrl(config_1.API.UMS.SIGNUP), { body: body, method: requestAdapter_1.RequestMethod.POST });
    };
    UMSModule.prototype.setDefault = function (alias) {
        this.tokenManager.setDefault(alias);
    };
    UMSModule.prototype.resetDefault = function () {
        this.tokenManager.resetDefault();
    };
    UMSModule.prototype.getUser = function (alias) {
        var _this = this;
        return this.tokenManager.token(alias)
            .then(function (token) { return _this.requestAdapter.execute(_this.getUrl(config_1.API.UMS.USER), { headers: { Authorization: "Bearer " + token } }); });
    };
    UMSModule.prototype.changePassword = function (alias, oldPassword, newPassword) {
        var _this = this;
        var body = {
            old_password: oldPassword,
            new_password: newPassword,
        };
        return this.tokenManager.token(alias)
            .then(function (token) { return _this.requestAdapter.execute(_this.getUrl(config_1.API.UMS.CHANGEPASSWORD), { body: body, headers: { Authorization: "Bearer " + token }, method: requestAdapter_1.RequestMethod.POST }); });
    };
    UMSModule.prototype.deleteUser = function (alias, password) {
        var _this = this;
        var body = { password: password };
        return this.tokenManager.token(alias)
            .then(function (token) { return _this.requestAdapter.execute(_this.getUrl(config_1.API.UMS.USER), { body: body, headers: { Authorization: "Bearer " + token }, method: requestAdapter_1.RequestMethod.DELETE }); });
    };
    UMSModule.prototype.getUrl = function (api, ums) {
        if (ums === void 0) { ums = true; }
        var url = config_1.API.PROTOCOL + "://" + this.projectId + "." + config_1.API.HOST + "." + config_1.API.DOMAIN + ":" + config_1.API.PORT;
        if (ums) {
            url += "/" + config_1.API.UMS.ENDPOINT;
        }
        return url + "/" + api;
    };
    return UMSModule;
}());
exports.UMSModule = UMSModule;
